import { SvgProps } from "../../types";

const Meter = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 15}
    height={props.height ? props.height : 15}
    fill="none"
    {...props}>
    <path
      fill={props.fill ? props.fill : "#666D87"}
      fillRule="evenodd"
      d="M13.926.375H2.26A1.667 1.667 0 0 0 .593 2.042v11.666a1.666 1.666 0 0 0 1.666 1.667h11.667a1.666 1.666 0 0 0 1.667-1.667V2.042A1.667 1.667 0 0 0 13.926.375Zm-7.5 13.333a.833.833 0 1 1 0-1.666.833.833 0 0 1 0 1.666Zm3.333 0a.833.833 0 1 1 0-1.666.833.833 0 0 1 0 1.666Zm3.334 0a.833.833 0 1 1 0-1.666.833.833 0 0 1 0 1.666Zm.833-3.333H2.26V2.042h11.667v8.333Zm-1.667-5H8.093V3.708h4.166v1.667Zm0 3.333H5.593V7.042h6.666v1.666Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Meter;
